export default "__VITE_ASSET__68reo0Ab__"